import * as actions from "../action.constants";

const initialState = {
  isLoading: false,
  organizationsData: {},
  selectedOrganization: {},
  apps: [],
};

const organizationsReceived = (state, action) => {
  return {
    ...state,
    organizationsData: action.responsePayload,
  };
};

const storeSelectedOrganization = (state, action) => {
  return {
    ...state,
    selectedOrganization: action.payload,
  };
};

const storeApps = (state, action) => {
  return {
    ...state,
    apps: action.payload,
  };
};

const handlers = {
  [actions.SAVE_ORGANIZATIONS_LIST]: organizationsReceived,
  [actions.STORE_ORGANIZATION]: storeSelectedOrganization,
  [actions.STORE_ORGANIZATIONS_APPS]: storeApps,
};

export default (state = initialState, action) => {
  const handler = handlers[action.type];
  if (typeof handler === "undefined") return state;
  return handler(state, action);
};
